import React from 'react'
import IconWrapper from './IconWrapper'

export const EditIcon = props => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="butt"
            strokeLinejoin="round"
        >
            <polygon points="16 3 21 8 8 21 3 21 3 16 16 3"></polygon>
        </svg>
    </IconWrapper>
)
